<ng-container *ngIf="origin && (!!title || !!text)">
  <glxy-popover
    [origin]="origin"
    [isOpen]="show"
    [positions]="positions"
    [hasArrow]="true"
    [padding]="title ? 'large' : 'small'"
    [highContrast]="highContrast"
  >
    <glxy-popover-title *ngIf="title">
      {{ title | translate }}
    </glxy-popover-title>
    <span *ngIf="text">{{ text | translate }}</span>
  </glxy-popover>
</ng-container>
